import TransactionStatusWidget from '@/components/TransactionStatusWidget'

const Status = () => {
  return (
    <div className="min-h-screen bg-transparent flex items-center justify-center p-4">
      <TransactionStatusWidget />
    </div>
  )
}

export default Status
